var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "21.000000pt",
    viewBox: "0 0 20.000000 21.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,21.000000) scale(0.100000,-0.100000)",
    fill: "#6a85f4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 172 c-44 -39 -44 -95 0 -134 26 -23 40 -28 85 -28 69 0 81 13 73 83 -12 96 -93 137 -158 79z m115 -3 c23 -18 26 -27 26 -85 l0 -64 -54 0 c-72 0 -106 26 -106 81 0 76 75 114 134 68z",
    fill: "#6a85f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 113 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z",
    fill: "#6a85f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 73 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z",
    fill: "#6a85f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgg1);
export default __webpack_public_path__ + "static/media/msgg1.b630034f83f6b01b788b98180f194f1a.svg";
export { ForwardRef as ReactComponent };